import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import BoxCard from "../components/BoxCard";
import WineCard from "../components/WineCard";
import { ArrowLeft } from "lucide-react";

export default function Regione() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/regions/${slug}`).then(r => setData(r.data)); }, [slug]);
  if (!data) return <div className="container-xl py-20">Caricamento…</div>;
  const { region, boxes, wines } = data;
  return (
    <div data-testid={`region-page-${slug}`}>
      <section className="relative h-[60vh] min-h-[400px] overflow-hidden">
        <img src={region.image} alt={region.name} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/30 to-black/15" />
        <div className="relative container-xl h-full flex flex-col justify-end pb-12">
          <Link to="/scopri" className="inline-flex items-center gap-2 text-sm text-white/90 mb-4 hover:text-white"><ArrowLeft className="h-4 w-4" />Tutte le regioni</Link>
          <div className="text-xs uppercase tracking-[0.4em] text-white/80">Regione</div>
          <h1 className="editorial-heading text-6xl md:text-8xl text-white leading-none">{region.name}</h1>
          <p className="text-white/80 text-lg mt-2">{region.tagline}</p>
        </div>
      </section>
      {boxes.length > 0 && (
        <section className="container-xl py-12">
          <h2 className="editorial-heading text-4xl mb-6">Box di {region.name}</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {boxes.map(b => <BoxCard key={b.id} box={b} />)}
          </div>
        </section>
      )}
      {wines.length > 0 && (
        <section className="container-xl py-12 border-t border-border">
          <h2 className="editorial-heading text-4xl mb-6">Vini di {region.name}</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {wines.map(w => <WineCard key={w.id} wine={w} compact />)}
          </div>
        </section>
      )}
    </div>
  );
}
